import { useRouter } from "vue-router";

import { useAuthenticationStore } from "@/store/authentication.store";
import { ACCOUNT_TYPE } from "@/constants";
import { buildOrgUrl } from "@/utils/navigation/orgUrl";

export const useRedirectBasedOnRole = () => {
  const authStore = useAuthenticationStore();
  const router = useRouter();

  return () => {
    const type = authStore.selectedAccount?.type_name;
    const orgUuid = authStore.selectedAccount?.uuid;

    if (type === ACCOUNT_TYPE.SYSTEM) {
      return router.push(buildOrgUrl("system", orgUuid));
    }

    if (type === ACCOUNT_TYPE.MSP) {
      return router.push(buildOrgUrl("msp", orgUuid));
    }

    if (type === ACCOUNT_TYPE.CUSTOMER) {
      return router.push(buildOrgUrl("customer", orgUuid));
    }

    return router.push("/auth");
  };
};
